import React, { useRef, useState } from 'react';
import ENUMS from '../../../enums';
import Select from 'react-select';
import '../styles.scss';

const DiscountCodeUsersFilter = props => {
  let formRefrence = useRef();
  let [userFullNamePart, setUserFullNamePart] = useState('');
  let [cafeNamePart, setCafeNamePart] = useState();
  let [isUseable, setUseability] = useState({ label: 'هردو', value: 'null' });
  let [userMobileNumberPart, setUserMobileNumberPart] = useState();
  let status = [...ENUMS.DISCOUNT_CODE_USERS_STATUS.list];

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setUserFullNamePart('');
    setUseability('null');
    setUserMobileNumberPart('');
    setCafeNamePart('');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => {
          props.applyFilters(event);
        }}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex col-12 justify-content-start align-items-center my-1">
            <div className="col-8 p-0 d-flex justify-content-center align-items-center">
              <div className="col-3">{locales('tables.useability')}</div>
              <div className="col-9">
                <Select
                  placeholder={locales('tables.useability')}
                  isMulti={false}
                  name="isUseable"
                  value={isUseable}
                  options={status.map(bankName => ({
                    label: bankName.title,
                    value: bankName.value
                  }))}
                  onChange={selectedIds => setUseability(selectedIds)}
                  className="full-width"
                />
              </div>
            </div>
          </div>
          <div className="d-flex col-12 justify-content-start align-items-center my-1">
            <div className="d-flex flex-column col-4 h-50 py-2 mx-1">
              <input
                onChange={event => setUserFullNamePart(event.target.value)}
                value={userFullNamePart || ''}
                name="userFullNamePart"
                type="text"
                className="form-control col-12"
                placeholder={locales('tables.fullName')}
                maxLength={ENUMS.MAX_LENGTH.fullName}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
            </div>
            <div className="d-flex flex-column col-4 h-50 py-2 mx-1">
              <input
                onChange={event => setCafeNamePart(event.target.value)}
                value={cafeNamePart || ''}
                name="cafeNamePart"
                type="text"
                className="form-control col-12"
                placeholder={locales('fields.cafe.name')}
                maxLength={ENUMS.MAX_LENGTH.cafeName}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.30')}</small>
            </div>
            <div className="d-flex flex-column col-4 h-50 pb-3 mx-1">
              <input
                onChange={event => setUserMobileNumberPart(event.target.value)}
                value={userMobileNumberPart || ''}
                name="userMobileNumberPart"
                type="text"
                className="form-control col-12"
                placeholder={locales('fields.mobileNumber')}
                maxLength={ENUMS.MAX_LENGTH.mobileNumber}
              />
            </div>
          </div>
          <div className="d-flex col-12 justify-content-end align-items-center my-1">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button
              type="submit"
              id="apply-filter-btn-discountCodeUsers"
              className="btn btn-success w-5 mx-2"
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default DiscountCodeUsersFilter;
